<template>
  <div
    class="land-card"
    :class="{
      disabled: info.coLandVO.shGisLandTypeId !== 1 || !info.insureFlag,
      selected: info.select,
    }"
  >
    <div class="land-name">{{ info.coLandVO.landName }}</div>
    <div class="description">
      <span class="area">{{ info.coLandVO.statisticsLandAcre }}亩</span
      ><span class="group">{{ info.coLandVO.landGroupName }}</span>
    </div>
    <div class="crop-info">
      <div class="name" v-if="info.coLandVO.shGisLandTypeId">
        {{ landType[info.coLandVO.shGisLandTypeId] }}
      </div>
      <div v-else></div>
      <div
        class="tips"
        v-if="info.coLandVO.shGisLandTypeId !== 1 || !info.insureFlag"
      >
        {{
          info.insureFailList[0]
            ? info.insureFailList[0]
            : "本地块类型暂不支持投保"
        }}
      </div>
    </div>
    <div v-if="info.select" class="selected-status">
      <i class="iconfont icon-gou1"></i>
    </div>
  </div>
</template>

<script>
const LAND_TYPE = [
  "",
  "粮田",
  "菜田",
  "经作田",
  "零星用地（其他）",
  "零星用地（已征地）",
  "零星用地（自留地/集体地）",
  "果园",
  "林地",
  "栏舍",
  "池塘",
];
export default {
  props: {
    info: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      landType: LAND_TYPE,
    };
  },
};
</script>

<style lang="scss" scoped>
.land-card {
  position: relative;
  width: 364px;
  height: 107px;
  box-sizing: border-box;
  padding: 16px;
  background: #ffffff;
  box-shadow: 0px 5px 20px rgba(85, 85, 124, 0.13);
  border-radius: 20px;
  border: 1px solid transparent;
  margin: 0 24px 24px 0;
  cursor: pointer;
  overflow: hidden;
  &:nth-child(3n) {
    margin-right: 0;
  }
  &:hover {
    box-shadow: 0px 5px 20px rgba(100, 195, 164, 0.2);
  }
  .land-name {
    width: 285px;
    font-weight: 500;
    font-size: 16px;
    line-height: 22px;
    color: #333333;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .description {
    font-size: 12px;
    margin-top: 4px;
    .area {
      color: #b2b2b2;
      margin-right: 12px;
    }
    .group {
      color: #888888;
    }
  }
  .crop-info {
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    margin-top: 12px;
    .name {
      display: inline-block;
      box-sizing: border-box;
      max-width: 143px;
      padding: 3px 9px;
      color: #ff831e;
      font-size: 12px;
      background: #fff2e8;
      border-radius: 10px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .tips {
      font-size: 12px;
      line-height: 14px;
      color: #ff831e;
    }
  }
  .selected-status {
    position: absolute;
    bottom: 0;
    right: 0;
    width: 0;
    height: 0;
    border: 28px solid transparent;
    border-right: 28px solid #64c3a4;
    border-bottom: 28px solid #64c3a4;
    .iconfont {
      color: #fff;
      font-size: 18px;
      position: absolute;
      top: -1px;
      left: 3px;
    }
  }

  &.selected {
    border: 1px solid $--color-primary;
  }

  &.disabled {
    cursor: not-allowed;
    .land-name {
      color: #cccccc;
    }
    .description {
      opacity: 0.5;
    }
    .crop-info {
      .name {
        background: #f7f9fb;
        color: #cccccc;
      }
    }
  }
}
</style>
